import React, { useState } from "react";
import "../style/LeaveMessage.css";

const LeaveMessage = () => {
  const [open, setOpen] = useState(false);

  const openForm = () => setOpen(true);
  const closeForm = () => setOpen(false);

  return (
    <div className="leave-message">

      {/* WHATSAPP FLOATING ICON */}
      <a
        href="https://wa.me/919773157265" target="_blank" className="whatsapp-icon"
      >
        
        <img src="./icons/whatsapp.png" alt="" width={"60px"}/>
      </a>

      {/* Sticky Button */}
      <button onClick={openForm}>💬 Leave a Message</button>

      {/* Form */}
      <div className={`leave-message-form ${open ? "show" : ""}`}>
        <div className="form-header">
          <h3>Leave a Message</h3>
          <span onClick={closeForm}>&times;</span>
        </div>

        <form>
          <label>Name</label>
          <input type="text" placeholder="Enter your name" required />

          <label>Email</label>
          <input type="email" placeholder="Enter your email" required />

          <label>Message</label>
          <textarea placeholder="Type your message" rows="4" required />

          <button type="submit">Send</button>
        </form>
      </div>
    </div>
  );
};

export default LeaveMessage;
